import type { ComponentProps } from "react";

import { cn } from "../../lib/cn";

/** The words every surface shows while its test data is on, so the console, the counter and the Reward Desk say the same thing. */
export const TEST_MODE_STRIP_WORDS = "Test mode is on. Sales and customers here are test data and won't show in your live reports.";

type TestModeStripProps = Omit<ComponentProps<"div">, "children"> & {
  /** Overrides the standard words, e.g. for another language. */
  readonly words?: string;
};

/**
 * A honey strip across the very top of a screen while Test mode is on. It is shown only from what the server says
 * about the business, never from a choice kept in the browser, and it names no way to turn Test mode off: that is a
 * setting, changed in the console.
 */
export function TestModeStrip({ words = TEST_MODE_STRIP_WORDS, className, ...rest }: TestModeStripProps) {
  return (
    <div
      {...rest}
      role="status"
      className={cn(
        "flex w-full items-center justify-center gap-2 bg-notice-bg px-4 py-2 text-center font-sans text-control font-medium leading-control text-text-body",
        className,
      )}
    >
      <span aria-hidden="true" className="size-2 shrink-0 rounded-cell bg-chart-2" />
      <span className="min-w-0">{words}</span>
    </div>
  );
}

export type { TestModeStripProps };
